(() => {
  function init() {
    const header = document.querySelector('.biony-header-section--floating');
    if (!header || header.dataset.scrollBound) return;
    header.dataset.scrollBound = 'true';

    const announcement = document.querySelector('.biony-announcement');

    const update = () => {
      const annHeight = announcement ? announcement.offsetHeight : 0;
      const y = window.scrollY;
      header.style.top = `${Math.max(0, annHeight - y)}px`;
      header.classList.toggle('biony-header-section--scrolled', y > annHeight + 20);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  init();
  document.addEventListener('shopify:section:load', init);

  // X del drawer: delega al summary para reusar la animación de cierre de Dawn
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.biony-drawer-close');
    if (!button) return;
    const summary = button.closest('details')?.querySelector('summary');
    if (summary) summary.click();
  });
})();
